import React from 'react';
import './Header.css';
import rower from '../../Assets/xmas-cropped.png';
import logo from '../../Assets/pursuing-health_logo.png';
import btwbLogo from '../../Assets/btwb_logo.svg';

function Header() {
	return(<header className="header relative">
		<div className="header-img absolute w-100 h-100"></div>
		<div className="super-header absolute top-0 mt0 ph3 pt2  w-100 white flex items-center">
			<div className="tl w-50">
				<a href="https://btwb.com">
					<img className="logo" src={btwbLogo} width="175" />
				</a>
			</div>
			<div className="tr w-50">
				<a href="http://juliefoucher.com/">
					<img className="logo" src={logo} width="200" />
				</a>
			</div>
		</div>
		<div className="header-text absolute mb3 white w-70 tl pl3 z-2">
			<div className="f5 f3-ns mb1 fw7">Marathon Row Challenge</div>
			<p className="f6 f5-ns mv0">Free for all btwb users. Add hashtags to the notes section of your row posts: #xmasrow & #team(name).<br/><br/></p> 
			<p className="mv0 f6 f5-ns"><a className="white" href="https://btwb.com/">Sign up for a free 30 day trial now</a></p>
		</div>
		<div className="header-rower absolute bottom-0 left-0 w-40 pl4">
			<img src={rower} />
		</div>
		<div className="header-content absolute pa3 bottom-0 right-0">
			{/*<h1 className="mb4 mt0 tc white f1">The Christmas Row</h1>*/}
			{/*<a className="no-underline db mr0" href="https://btwb.com">
				<div className="header-button pa3 center mb3">Join Us</div>
			</a>*/}
			<a className="no-underline db mr0" href="https://btwb.blog/2019/12/04/marathon-row-challenge/">
				<div className="header-button pa3 center mb3">Details</div>
			</a>
		</div>
	</header>)
}

export default Header;